import React from "react";
import { useTranslation } from "react-i18next";
import doneIcon from "../../../assets/images/reg-done.png";
import leftArrow from "../../../assets/images/arrow-left.png";
import { useHistory } from "react-router-dom";
import "./RegFourthStep.scss";

const RegFourthStep = () => {
  const { t } = useTranslation("common");
  const history = useHistory();

  const openLoginPage = () => {
    history.push("/login");
  };

  return (
    <div className="reg-fourth-step-wraper">
      <img src={doneIcon} alt="done" />
      <span className="fourth-step-label">{t("RegFourthStep.success")}</span>
      <button onClick={openLoginPage}>
        <span>{t("RegFourthStep.enter")}</span>
        <img src={leftArrow} alt="left" />
      </button>
    </div>
  );
};

export default RegFourthStep;
